import createAppSlice from 'app/createAppSlice';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  IPlan,
  IAvailableOffer,
  IPlanChangeEligibility,
  IPlanFeature,
} from './types';

const initialState: IPlan = {
  entitlements: {},
  entitlementsLoaded: false,
  availableOffers: [],
  availableOffersLoaded: false,
  planChangeEligibility: null,
  rawPlanFeatures: [],
};

const PlanSlice = createAppSlice({
  name: 'plan',
  initialState,
  reducers: {
    setPlanEntitlements: (
      state,
      action: PayloadAction<IPlan['entitlements']>,
    ) => {
      state.entitlements = action.payload;
      state.entitlementsLoaded = true;
    },
    setAvailableOffers: (state, action: PayloadAction<IAvailableOffer[]>) => {
      state.availableOffers = action.payload;
      state.availableOffersLoaded = true;
    },
    setPlanChangeEligibility: (
      state,
      action: PayloadAction<IPlanChangeEligibility>,
    ) => {
      state.planChangeEligibility = action.payload;
    },
    resetAvailableOffers: (state) => {
      state.availableOffers = [];
      state.availableOffersLoaded = false;
    },
    /* Stores the `features` array from the `GET /api/client/plans/`
     * response. Angular reads the same shape at
     * `apps/igww/src/app/user/user-plan.service.ts:91-96` to derive
     * `dark_web_child` and `ssn_trace` child-feature entitlements. */
    setRawPlanFeatures: (state, action: PayloadAction<IPlanFeature[]>) => {
      state.rawPlanFeatures = Array.isArray(action.payload)
        ? action.payload
        : [];
    },
  },
});

export const {
  setPlanEntitlements,
  setAvailableOffers,
  setPlanChangeEligibility,
  resetAvailableOffers,
  setRawPlanFeatures,
} = PlanSlice.actions;
export default PlanSlice.reducer;
